import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import EdPresentationModeAlert from '@/content/components/ed-presentation-mode/ed-presentation-mode-alert/ed-presentation-mode-alert.component.vue';
import { PUBLIC_NAV, MAIN_MENU } from '@/core/values/core.values';
import EdNavSubmenu from '@/core/components/ed-nav-submenu/ed-nav-submenu.component.vue';
import NavMixin from '@/core/mixins/nav.mixin';
import { APP_EVENT_BUS } from '@/core/enums/app.enum';

@Component({
  name: 'ed-nav',
  components: {
    EdPresentationModeAlert,
    EdNavSubmenu
  }
})
export default class EdNav extends Mixins(NavMixin) {

  initMenu() {
    const isUserLogged = !!this.$store.state.AuthStore.user.id;
    const menu = isUserLogged ? MAIN_MENU : PUBLIC_NAV;
    const menuSelected = this.getMenu(menu);

    menuSelected[1].verifyPresentationMode = !this.isPublisher;
    this.mainSelected = menuSelected;
    this.menuFormated = [...this.mainSelected];
  }

  created() {
    this.initMenu();
    this.$edEventBus.$on(APP_EVENT_BUS.LANGUAGE_CHANGED, this.initMenu);
  }

  beforeDestroy() {
    this.$edEventBus.$off(APP_EVENT_BUS.LANGUAGE_CHANGED, this.initMenu)
  }
}